import * as ls from 'local-storage';
import { apiInterceptor } from 'utils/apiInterceptor';

export default async function GenerateOtp(payload) {
    const auth = ls.get('auth');
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${auth?.access_token}`,
    };
    const data = JSON.stringify(payload);

    const { response } = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/accounts/otp`,
        {
            method: 'POST',
            headers,
            body: data,
        }
    );

    return await response.json();
}
